import Router from 'next/router';
import getConfig from 'next/config';
import pathToRegexp from 'path-to-regexp';

import {getAppRoutes} from '~/server/routes';
import {hasProtocol} from '~/src/utilities/helpers/link';
import {compileSitemap} from '~/server/utils/sitemap';

const {publicRuntimeConfig: config} = getConfig();

const parsedRoutes = getAppRoutes(config).map((route) => {
    const params = [];
    const path = pathToRegexp(route.path, params);
    return {
        ...route,
        params,
        path
    };
});

const getRoute = (sitemap, href) => {
    if (typeof href !== 'string' || hasProtocol(href)) {
        return href;
    }

    const path = href.split('#')[0].split('?')[0];
    const route = parsedRoutes.find((item) => item.path.test(path));
    if (route) {
        const match = route.path.exec(path);
        const params = route.params.reduce((acc, param, index) => {
            if (typeof param.name === 'string') {
                acc[param.name] = match[index + 1];
            }

            return acc;
        }, {});

        const {page: pathname, query} = route.page({sitemap: compileSitemap(sitemap, config), query: params});
        return {pathname, query: {...params, ...query}};
    }
};

const pushRoute = (sitemap, href, replace = false) => {
    const route = getRoute(sitemap, href);

    if (route) {
        if (replace) {
            Router.replace(route, href, {shallow: true});
        } else {
            Router.push(route, href);
        }
    }
};

export {getRoute, pushRoute};
